import {
  Button,
  Card,
  Heading,
  Text,
  List,
  CheckIcon,
  Badge,
  NotifyMeIcon,
  Strong,
} from '@buffer-mono/popcorn'

import styles from '../../InstagramSelectAccountType.module.css'

import type { JSX } from 'react'

export function PersonalProfileCard({
  onPersonalSelect,
}: {
  onPersonalSelect: () => void
}): JSX.Element {
  return (
    <Card className={styles.personalCard}>
      <Heading className={styles.heading}>Personal</Heading>
      <Badge className={styles.badge} size="small" variant="neutral">
        <NotifyMeIcon size="small" />
        Notification-Based Posting Only
      </Badge>
      <Text
        size="sm"
        className={styles.badgeMobileTextNeutral}
        icon={<NotifyMeIcon size="small" />}
      >
        Notification-Based Posting Only
      </Text>
      <List>
        <List.Item icon={CheckIcon} color="neutral">
          <Text>
            <Strong>Notifications</Strong> - We notify you, then you finish in
            app
          </Text>
        </List.Item>
      </List>

      <Button
        onClick={(): void => onPersonalSelect()}
        size="large"
        variant="secondary"
        className={styles.action}
      >
        Setup a Personal Account
      </Button>
    </Card>
  )
}
